export default __webpack_public_path__ + "static/media/money1.c733dcc9.jpg";